module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-abstract-hamilton-1.a616201a.jpg";